import {
  USER_DATA,
  USER_EDIT,
  USER_ADD,
  USER_ADD_LOADER,
  USER_DELETED,
  USER_RESET_SUCCESS,
  USER_DATA_BY_ROLE
} from "../actions/types";

const DEFAULT_STATE = {
  isSucess: false,
  errorMessage: '',
  userData: [],
  userDataByRole: [],
  isShowLoader: false
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case USER_DATA:
      return {
        ...state,
        userData: action.payload,
        isShowLoader: false,
        isSuccess: false,
        errorMessage: '',
      };
    case USER_ADD:
      return {
        ...state,
        isSuccess: action.payload.success,
        errorMessage: action.payload.message,
        isShowLoader: false,
      };
    case USER_ADD_LOADER:
      return {
        ...state,
        isShowLoader: action.payload,
        isSuccess: false,
        errorMessage: '',
      };
    case USER_EDIT:
      return {
        ...state,
        isSuccess: action.payload.success,
        errorMessage: action.payload.message,
        isShowLoader: false,
      };
    case USER_DELETED:
      return {
        ...state,
        isShowLoader: false,
        userDataByRole: state.userDataByRole.filter(
          user => user._id !== action.payload.userId
        )
      };
    case USER_RESET_SUCCESS:
      return {
        ...state,
        isSuccess: false,
        errorMessage: ''
      };
    case USER_DATA_BY_ROLE:
      return {
        ...state,
        userDataByRole: action.payload,
        isShowLoader: false,
      };
    default:
      return state;
  }
};
